module.exports = __webpack_public_path__ + "pc/img/swiper_logo_05.d3d814c6.png";